const SubstanceLists = {
    CANDIDATE_LIST: 'candidate_list',
    ROHS: 'rohs',
    POPS: 'pops',
    FMV: 'fmv',
    REACH_ANN_17: 'reach_ann_17',
    OZON_DEPLETING_SUBSTANCES: 'ozon_depleting_substances',
    GWP: 'gwp',
    THREE_TG: '3tg',

    toArray() {
        return [
            this.CANDIDATE_LIST,
            this.ROHS,
            this.POPS,
            this.FMV,
            this.REACH_ANN_17,
            this.OZON_DEPLETING_SUBSTANCES,
            this.GWP,
            this.THREE_TG,
        ]
    },
}

const SubstanceListRenderMode = {
    DEFAULT: 'default',
    SEARCH_ONLY: 'search-only',
    CONTAINER_ONLY: 'container-only',
}

export {
    SubstanceLists,
    SubstanceListRenderMode,
}
